<template>
  <section-container>
    <div class="w-full flex justify-center items-center flex-wrap p-2">
      <div class="w-full lg:w-1/3 flex flex-wrap flex-col">
        <h2 class="text-4xl font-bold mb-2">Pedidos</h2>
        <h3 class="text-xl mb-2 text-gray-600">Listando todos os pedidos</h3>
        <!-- <div class="my-5">
          <router-link
            class="px-6 py-4 text-md rounded font-bold text-white bg-indigo-600 hover:bg-indigo-700 border-indigo-500"
            :to="{ name: 'orders.create' }"
          >
            <font-awesome-icon icon="plus" class="mr-2" />
            Adicionar novo pedido
          </router-link>
        </div> -->
      </div>

      <div class="w-full lg:w-2/3 flex justify-center items-center px-4">
        <img
          src="@/assets/img/orders.png"
          alt=""
          width="650px"
          class="h-auto overflow-hidden"
        />
      </div>
    </div>
    <content-e>
      <div class="w-full rounded-lg bg-white shadow-2l">
        <div class="overflow-auto sm:overflow-x-auto md:overflow-x-auto p-5">
          <table class="text-left w-full table-responsive">
            <thead>
              <tr>
                <th
                  class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Cliente
                </th>

                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Total
                </th>

                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Método de pagamento
                </th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Status
                </th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                >
                  Data do pedido
                </th>
                <th
                  class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                ></th>
              </tr>
            </thead>
            <tbody v-for="item in items" :key="item.id">
              <tr>
                <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                  {{ item.customer_email }}
                  <small class="block text-gray-600 font-normal lowercase">
                    {{ item.customer_name }}
                  </small>
                </td>
                <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                  {{ item.total_price | toCurrency }}
                </td>
                <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                  {{ item.store_payment_method ? item.store_payment_method.name : null }}
                </td>

                <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                  <span
                    class="rounded-lg relative inline-block px-3 py-1 font-bold leading-tight"
                    :class="`status-${item.order_status.id}`"
                  >
                    <span class="relative">{{ item.order_status.name }}</span>
                  </span>
                </td>
                <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                  {{ item.created_at | moment('DD/MM/YYYY HH:mm') }}
                </td>
                <td
                  class="border-dashed border-t border-gray-200 px-3 py-3 text-sm"
                >
                  <router-link
                    :to="{ name: 'orders.show', params: { id: item.id } }"
                    class="mr-1 relative inline-block px-2 py-1 font-bold text-blue-500 leading-tight bg-blue-100 rounded-full"
                  >
                    <font-awesome-icon icon="eye" />
                    <ui-tooltip position="bottom" animation="fade"
                      >Visualizar</ui-tooltip
                    >
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="w-full mt-5">
        <pagination
          :pagination="pagination"
          @paginate="myOrder()"
          :offset="3"
        ></pagination>
      </div>
    </content-e>
  </section-container>
</template>

<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination'
export default {
  name: 'estico.index',
  components: {
    pagination: Pagination
  },
  data() {
    return {
      items: [],
      pagination: {}
    }
  },
  methods: {
    myOrder() {
      const page = this.pagination.current_page
        ? this.pagination.current_page
        : 1
      this.$store.dispatch('MY_ORDERS', page).then(response => {
        this.items = response.data.data
        this.pagination = {
          total: response.data.total,
          per_page: response.data.per_age,
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          from: response.data.from,
          to: response.data.to
        }
      })
    }
  },
  mounted() {
    this.myOrder()
  }
}
</script>
